export const rentalVehicleOptions = [
  {
    key: 'economy',
    title: 'Economy',
    subtitle: 'Corolla or similar',
    price: 75,
    priceLabel: 'From $75 / day',
    description:
      'Best for simple city driving, airport arrivals, and travelers who want the most budget-friendly option with basic insurance included.',
  },
  {
    key: 'standard',
    title: 'Standard',
    subtitle: 'Mazda or similar',
    price: 100,
    priceLabel: 'From $100 / day',
    description:
      'A comfortable step up for travelers who want a little more space and a smoother everyday rental feel with basic insurance included.',
  },
  {
    key: 'convertible',
    title: 'Convertible',
    subtitle: 'Mustang',
    price: 125,
    priceLabel: 'From $125 / day',
    description:
      'Good if you want a more Miami-style rental for beach drives, photos, and a more fun open-air option with basic insurance included.',
  },
  {
    key: 'suv',
    title: 'SUV',
    subtitle: 'SUV or similar',
    price: 125,
    priceLabel: 'From $125 / day',
    description:
      'Best for travelers who want extra room, more luggage space, or a more versatile vehicle than a standard rental car with basic insurance included.',
  },
  {
    key: 'luxury',
    title: 'Luxury / Exotic',
    subtitle: 'Luxury vehicle by request',
    price: null,
    priceLabel: 'Quote required',
    quoteOnly: true,
    description:
      'Call or text if you want a premium or exotic model and we can check availability, pricing, and insurance details for you.',
  },
  {
    key: 'special-request',
    title: 'Special Request',
    subtitle: 'Custom vehicle search',
    price: null,
    priceLabel: 'Call or text',
    quoteOnly: true,
    description:
      'If you want something outside the standard lineup, reach out and we can check availability and pricing for you.',
  },
];

export function getRentalVehicleOption(optionKey) {
  return rentalVehicleOptions.find((option) => option.key === optionKey) || null;
}

export function getDefaultRentalVehicleOption() {
  return rentalVehicleOptions.find((option) => !option.quoteOnly) || rentalVehicleOptions[0];
}
